<template>
  <div>
    <div class="page-title">New Redirect</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add Redirect"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.redirects.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Redirect",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Page.new();
      this.form = {
        ...data,
        url_type: "redirect",
        add_to_menu: "hidden",
      };
    },
    async create() {
      await this.$api.Page.create(this.form);
      this.$router.push("/redirects");
    },
  },
};
</script>

<style></style>
